import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import { AbyssCommonContent } from "../../../../modules/content/components/AbyssCommonContent/AbyssCommonContent";
import { AbyssSection } from "../../../../modules/content/components/AbyssSection/AbyssSection";
import type { IVideoBlockProps } from "./VideoBlock.props";

export const VideoBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
  videoBanner,
  videoSource,
  vimeoVideo,
  youtubeVideo,
}: IVideoBlockProps) => {
  const selectedVideo = videoSource === "youtube" ? youtubeVideo : vimeoVideo;
  if (!selectedVideo) return null;
  return (
    <AbyssSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <AbyssCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <VideoPlayer
          banner={videoBanner}
          source={videoSource}
          vimeoVideo={vimeoVideo}
          youtubeVideo={youtubeVideo}
        />
      </div>
    </AbyssSection>
  );
};

VideoBlock.displayName = "Block::VideoBlock";
